import { defineMessage, MessageDescriptor } from "react-intl";
import { define } from "cooky-cutter";
import { faker } from "@faker-js/faker";

export type EntityKey = "asset" | "device" | "trip" | "alert" | "reader";

export interface SearchableEntity {
  key: EntityKey;
  label: MessageDescriptor;
  apiPath: string;
  placeholder: MessageDescriptor;
}
export const searchableEntityFactory = define<SearchableEntity>({
  key: faker.helpers.arrayElement([
    "asset",
    "device",
    "trip",
    "alert",
    "reader",
  ]),
  label: {
    defaultMessage: faker.lorem.sentence(),
  },
  apiPath: faker.string.alpha(),
  placeholder: {
    defaultMessage: faker.lorem.sentence(),
  },
});

export const assetEntity: SearchableEntity = {
  key: "asset",
  label: defineMessage({
    defaultMessage: "Assets",
    description:
      "Label for navigation and selection of physical asset entities like containers and trailers",
  }),
  apiPath: "assets",
  placeholder: defineMessage({
    defaultMessage: "Search assets...",
    description:
      "Placeholder text shown in search input when searching for physical assets like containers or trailers",
  }),
};
export const deviceEntity: SearchableEntity = {
  key: "device",
  label: defineMessage({
    defaultMessage: "Sensors",
    description:
      "Label for navigation and selection of IoT tracking device entities",
  }),
  apiPath: "devices",
  placeholder: defineMessage({
    defaultMessage: "Search sensors...",
    description:
      "Placeholder text shown in search input when searching for IoT sensors and tracking devices",
  }),
};
export const tripEntity: SearchableEntity = {
  key: "trip",
  label: defineMessage({
    defaultMessage: "Trips",
    description:
      "Label for navigation and selection of shipment journey entities in the supply chain",
  }),
  apiPath: "trips",
  placeholder: defineMessage({
    defaultMessage: "Search trips...",
    description:
      "Placeholder text shown in search input when searching for shipment journeys between locations",
  }),
};
export const alertEntity: SearchableEntity = {
  key: "alert",
  label: defineMessage({
    defaultMessage: "Alerts",
    description:
      "Label for navigation and selection of supply chain notification entities",
  }),
  apiPath: "alerts",
  placeholder: defineMessage({
    defaultMessage: "Search alerts...",
    description:
      "Placeholder text shown in search input when searching for supply chain alerts and notifications",
  }),
};
export const readerEntity: SearchableEntity = {
  key: "reader",
  label: defineMessage({
    defaultMessage: "Readers",
    description: "Label for navigation and selection of reader entities",
  }),
  apiPath: "readers",
  placeholder: defineMessage({
    defaultMessage: "Search readers...",
    description:
      "Placeholder text shown in search input when searching for readers",
  }),
};
